import { cookiesBannerInit } from './libs/cookies-banner';

cookiesBannerInit();
